export default {
  tabLabel: 'Аудит',
  loadingAudit: 'Загружаю аудит…',
  loadAuditError: 'Не удалось загрузить аудит: {{message}}',
  contextDebtTitle: 'Контекстный долг',
  contextDebtDescription:
    'Насколько тяжело восстановить рабочий контекст без обращения к людям.',
  collectingData: 'Собираю данные…',
  collectData: 'Собрать данные',
  generatingReport: 'Формирую…',
  generateReport: 'Сформировать отчёт',
  ingestError: 'Сбор данных не удался: {{message}}',
  generateError: 'Не удалось сформировать отчёт: {{message}}',
  clearHistoryError: 'Не удалось очистить историю: {{message}}',
  scanFailed: 'Прогон упал: {{message}}',
  metricsTitle: 'Метрики',
  noData:
    'Данных пока нет. Подключите источники в разделе «Плагины» и нажмите «Собрать данные».',

  chartNotEvaluated:
    'Context Debt не оценивался: ни один источник не дал данных.',
  debtBandLow: 'низкий',
  debtBandModerate: 'умеренный',
  debtBandHigh: 'высокий',
  debtBandCritical: 'критический',
  trendAfterReport:
    'Тренд появится после первого сформированного отчёта: линия рисуется по зафиксированным версиям, а не по текущему превью.',
  oneMeasurement:
    'Пока один замер: линия показывает подъём от нуля, а не движение во времени. Сравнивать будет с чем со следующего отчёта.',
  zeroDebt: '0 — долга нет',
  hundredDefective: '100 — дефектен каждый объект',

  sourceCalendar: 'Календарь',
  sourceGoogleCalendar: 'Google Calendar',
  sourceYandexCalendar: 'Яндекс Календарь',
  sourceOutlookCalendar: 'Outlook Calendar',
  sourceOther: 'Другое',
  sourceHasData: 'данные есть',
  sourceNoData: 'данных нет',
  sourceNotConnected: 'не подключено',
  sourceFailed: 'сбой',
  sourceStatusHint: 'Статус источника получен во время последнего сбора.',

  componentTaskDebt: 'Качество задач',
  componentDocumentationDebt: 'Документация',
  componentTraceabilityDebt: 'Контекст изменений',
  componentDecisionDebt: 'Решения без записи',
  componentMeetingDebt: 'Встречи',
  componentKnowledgeConcentration: 'Концентрация знаний',

  signalMissingDescription: 'Без содержательного описания',
  signalMissingAcceptanceCriteria: 'Без критериев приёмки',
  signalMissingPriority: 'Без приоритета',
  signalMissingEstimate: 'Без оценки',
  signalMissingAssignee: 'Без владельца',
  signalMissingEpicLink: 'Без связи с эпиком',
  signalStaleDocument: 'Давно не обновлялись',
  signalOrphanDocument: 'Без входящих связей',
  signalThinDocument: 'Слишком короткие',
  signalPullRequestWithoutIssue: 'Без ссылки на задачу',
  signalPullRequestUnknownIssue: 'Ссылка на неизвестную задачу',
  signalPullRequestLongDiscussion:
    'Длинное обсуждение: {{threshold}}+ комментариев',
  signalSingleContributor: 'Область с единственным участником',
  signalDominatedArea:
    'Область, где один участник держит {{threshold}}% и больше',
  signalDecisionWithoutRecord: 'Решение обсуждалось, но ссылки на документ нет',
  signalMeetingWithoutAgenda: 'Без агенды в описании встречи',
  signalWeeklyMeetingOverload:
    'Сверх мягкого лимита {{threshold}} встреч в неделю',

  measured: 'Измерено',
  estimate: 'Оценка',
  weight: 'вес {{value}}',
  notEvaluated: 'Не оценивалось',
  measuredSummary: '{{deficient}} из {{total}} задач — {{percent}}',
  estimatedSummary: 'оценочно {{low}}…{{high}}',
  assumptionsTitle: 'Допущения оценки',
  dataCompleteness: 'Полнота доступных данных: {{percent}}',
  assumptionSoftWeeklyLimit: 'Мягкий недельный лимит',
  assumptionHardWeeklyLimit: 'Жёсткий недельный лимит',
  unitMeetingShare: 'доля встреч',
  unitMeetingsPerWeek: 'встреч/неделю',
  show: 'Показать',
  hide: 'Скрыть',
  loadingList: 'Загружаю список…',
  emptyList:
    'Список пуст: в зафиксированном отчёте по этому признаку записей нет.',
  drilldownUnavailable: 'Детализация недоступна для этого отчёта.',
  drilldownLoadError: 'Не удалось загрузить список: {{message}}',
  pendingReview: 'ждёт ревью',

  economyTitle: 'Во что это обходится',
  contextRecoveryCost: 'на восстановление контекста по найденным дефектам',
  range: 'диапазон {{low}} … {{high}}',
  showCalculation: 'Показать расчёт',
  hideCalculation: 'Скрыть расчёт',
  calculationLine: '{{count}} × {{minutes}} мин',
  economyAssumptions:
    'Константы времени — допущения, а не измерения. Их можно изменить, и оценка пересчитается.',
  hourShort: 'ч',

  recommendationsTitle: 'Что делать',
  effortLow: 'быстро',
  effortMedium: 'средне',
  effortHigh: 'долго',
  laplacePreparesDraft: 'Laplace готовит черновик',
  estimatedHours: 'оценочно {{low}}…{{high}} ч',
  recommendationGenerateTaskDescriptionsTitle:
    'Задачи без содержательного описания',
  recommendationGenerateTaskDescriptionsAction:
    'Сгенерировать черновики описаний и отправить на ревью.',
  recommendationGenerateAcceptanceCriteriaTitle: 'Задачи без критериев приёмки',
  recommendationGenerateAcceptanceCriteriaAction:
    'Сгенерировать критерии приёмки из описания и обсуждения.',
  recommendationAddEstimatesTitle: 'Задачи без оценки',
  recommendationAddEstimatesAction:
    'Проставить оценки на груминге. Автоматизировать нельзя: это решение команды.',
  recommendationAssignOwnersTitle: 'Задачи без владельца',
  recommendationAssignOwnersAction:
    'Назначить владельцев. Кто отвечает — решает команда, не сервис.',
  recommendationLinkTasksToEpicsTitle: 'Задачи без связи с эпиком',
  recommendationLinkTasksToEpicsAction:
    'Привязать задачи к эпикам, чтобы контекст восстанавливался сверху.',
  recommendationRefreshStaleDocumentsTitle: 'Документы давно не обновлялись',
  recommendationRefreshStaleDocumentsAction:
    'Обновить или архивировать. Устаревший документ хуже отсутствующего: ему верят.',
  recommendationLinkOrphanDocumentsTitle: 'Документы без входящих связей',
  recommendationLinkOrphanDocumentsAction:
    'Связать со задачами или удалить. Ненайденный документ не работает.',
  recommendationReviewThinDocumentsTitle: 'Слишком короткие документы',
  recommendationReviewThinDocumentsAction:
    'Дополнить или объединить: страница-заглушка контекста не несёт.',
  recommendationEnforceIssueKeyTitle: 'Pull request без ссылки на задачу',
  recommendationEnforceIssueKeyAction:
    'Ввести правило именования веток с ключом задачи. Прошлые PR восстановить уже нельзя — это про процесс.',
  recommendationFixUnknownIssueKeysTitle:
    'Pull request со ссылкой на неизвестную задачу',
  recommendationFixUnknownIssueKeysAction:
    'Проверить опечатки в ключах и охват проектов в аудите: часть ссылок может вести в другой трекер.',
  recommendationReducePrClarificationsTitle:
    'Pull request с длинным обсуждением',
  recommendationReducePrClarificationsAction:
    'Посмотреть, о чём переспрашивали: обычно это признак, что задача или документация не объясняли контекст.',
  recommendationAddMeetingAgendasTitle: 'Встречи без агенды',
  recommendationAddMeetingAgendasAction:
    'Добавить ожидаемый результат и список вопросов в описание повторяющихся встреч.',
  recommendationReduceWeeklyMeetingsTitle: 'Слишком много встреч в неделю',
  recommendationReduceWeeklyMeetingsAction:
    'Проверить повторяющиеся встречи, объединить дубли и заменить необязательные синхронизации асинхронным обновлением.',
  recommendationRecordDecisionsTitle: 'Решения обсуждались, но не записаны',
  recommendationRecordDecisionsAction:
    'Оформить решение отдельной записью и связать с задачей.',
  recommendationReduceSingleContributorAreasTitle:
    'Области с единственным носителем контекста',
  recommendationReduceSingleContributorAreasAction:
    'Добавить второго участника или выгрузить контекст в документацию.',
  recommendationSpreadAreaOwnershipTitle:
    'Области, где почти всё держит один человек',
  recommendationSpreadAreaOwnershipAction:
    'Распределить задачи области шире хотя бы частично.',

  draftsTitle: 'Черновики',
  draftsSummary: '{{pending}} на ревью, {{approved}} готовы к записи',
  draftStatusPendingReview: 'ждёт ревью',
  draftStatusApproved: 'одобрен',
  draftStatusRejected: 'отклонён',
  draftStatusApplied: 'записан в трекер',
  draftStatusFailed: 'запись не удалась',
  field: 'поле: {{field}}',
  approve: 'Одобрить',
  reject: 'Отклонить',
  retryApply: 'Повторить запись',
  applyToTracker: 'Записать в трекер',
  draftsNote:
    'До одобрения в трекер не уходит ничего, и задача продолжает считаться дефицитной.',

  historyTitle: 'История отчётов',
  clearHistoryConfirmation: 'Удалить все версии? Тренд и детализация пропадут.',
  clearing: 'Очищаю…',
  delete: 'Удалить',
  cancel: 'Отмена',
  clearHistory: 'Очистить историю',
  noChanges: 'без изменений',
} as const
